/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { ICommonResponse, IStudentProject } from '../../api/types';
import { GET_STUDENT_PROJECTS } from '../../actions';

export type StudentProjectsState = ICommonResponse<IStudentProject>;

const initialState = {
  content: [],
  loading: false,
} as ICommonResponse<IStudentProject>;
const generic = genericReducers<StudentProjectsState>();
const studentProjects: IReducers<StudentProjectsState> = {
  [GET_STUDENT_PROJECTS[REQUEST]]: generic.get.request,
  [GET_STUDENT_PROJECTS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_PROJECTS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_PROJECTS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentProjects);
